import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import LegendIcon from 'components/CopilotControl/icons/LegendIcon'

const useStyles = makeStyles(() => ({
  legendItem: {
    margin: 5,
    marginTop: 10
  }
}))

const ScoresLegend = ({ scoreOptions }) => {
  const classes = useStyles()

  return (
    <Grid container>
      {Object.entries(scoreOptions).map(([optionKey, { strokeColor, label }], index) => (
        <Grid item key={index}>
          <IconAndText
            icon={<LegendIcon color={strokeColor} />}
            text={
              <DazzedHeadingForGrid
                bold
                xs={10}
                sm={10}
                md={10}
                lg={12}
                style={{ color: '#727B8C', padding: '0px 0px' }}
              >
                {label}
              </DazzedHeadingForGrid>
            }
            className={classes.legendItem}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default ScoresLegend
